module.exports = "/_next/static/images/logo-e29c41950941d46ed538b337b7195ec6.png";